import {
  Box,
  Button,
  Checkbox,
  Grid,
  Pagination,
  PaginationItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearDeliveredOrderInfo,
  clearIntransitOrderInfo,
  getIntransitOrderData,
  handleRefreshTabData,
  refreshIntransitOrderData,
  refreshPendingOrderData,
  selectAllIntransitRows,
} from "../../../reducers/orders/ordersSlice";
import ListEmptyCard from "../../../components/ListEmptyCard";
import ProductionQuantityLimitsOutlinedIcon from "@mui/icons-material/ProductionQuantityLimitsOutlined";
import ThreeDotLoader from "../../../components/ThreeDotLoader";
import moment from "moment";
import {
  formatMSToHoursAndMinutes,
  formatStrTime,
  getOrderDeliveryTypeText,
  getOrderType,
} from "../../../utils/helper";
import InfiniteScroll from "react-infinite-scroll-component";
import OrderIntransitCard from "../Cards/OrderIntransitCard";
import SearchOrdersById from "../SearchOrdersById";
import HorizontalStepper from "../../../components/HorizontalStepper";
import OrderCancelPopup from "../CancelOrderPopup/OrderCancelPopup";

import {
  blackShade19,
  blackShade23,
  blueColor04,
  greyColor21,
  greyColor42,
  mobilePrimary,
  orangeColor02,
  orderCardBorder,
  orderCardHeadingBorder2,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { stickyHeader } from "../../../utils/styles";
import {
  deliveryStatusShippmentApi,
  orderDeliveredShippmentApi,
  unicomGetSaleOrder,
  unicommerceForceDispatch,
} from "../../../service/api_calls/orders/OrdersApi";
import ActionInfoHeader from "../Cards/ActionInfoHeader";
import BulkDownloadContent from "../Popups/BulkDownloadContent";
import DownloadIcon from "@mui/icons-material/Download";

function IntransitOrdersContent({
  handleTrackOrder,
  handleViewOrder,
  steps,
  tabValue,
  handleResendB2B,
  handleResend,
  error,
  success,
  commerceInfo,
  getOndcBapNameBySubscriberId,
  downloadShipingLabel,
  downloadInvoiceAndShipingLabel,
  invoiceDownloadLoader,
  downloadInvoice,
  totalOrders,
}) {
  const PAGE_SIZE = 25;

  const dispatch = useDispatch();
  const [hasMoreData, setHasMoreData] = useState(true);
  const [sortFilter, setSortFilter] = useState({
    label: "Newest Order First",
    value: "desc",
  });

  const [isSearchActive, setIsSearchActive] = useState(false);

  const [openCancelOrder, setOpenCancelOrder] = useState({
    show: false,
    data: null,
  });

  const [openApproveOrder, setOpenApproveOrder] = useState({
    show: false,
    data: null,
  });

  const [bulkDownload, setBulkDownload] = useState(null);
  const [bulkDownloadError, setBulkDownloadError] = useState("");
  const [page, setPage] = useState(1);

  const {
    intransitOrders,
    intransitPageNo,
    intransitOrdersLoader,
    selectedInTransitRowCount,
  } = useSelector((state) => state.businessOrders);

  const [unicomError, setUnicomError] = useState("");

  const getOrdersData = (pageNo) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    dispatch(
      getIntransitOrderData({
        businessId,
        pageSize: PAGE_SIZE,
        pageNo: pageNo,
        sortBy: sortFilter?.value || "desc",
      })
    );
  };

  const fetchNextData = () => {
    // console.log("Next Hit");
    getOrdersData();
  };

  // Open Cancel Order Popup
  const handleCancelOrder = (data) => {
    console.log("CANCEL_ORDER__:", data);
    setOpenCancelOrder({ show: true, data });
    // dispatch(handleRefreshTabData());
  };

  // handle Searching
  const onSearchStart = () => {
    setIsSearchActive(true);
    dispatch(clearIntransitOrderInfo());
  };

  const onSearchClear = () => {
    setIsSearchActive(false);
    getOrdersData(1);
  };

  // Open Approve Order Popup
  const handleApproveOrder = (data) => {
    setOpenApproveOrder({ show: true, data });
  };

  const handleApproveSuccess = () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    setOpenApproveOrder({ show: false, data: null });
    dispatch(handleRefreshTabData());
    dispatch(
      refreshPendingOrderData({
        businessId,
        pageSize: PAGE_SIZE,
        pageNo: 1,
        sortBy: sortFilter?.value || "desc",
      })
    );
  };
  const handleSucessIntransit = () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    setOpenApproveOrder({ show: false, data: null });
    dispatch(handleRefreshTabData());
    dispatch(
      refreshIntransitOrderData({
        businessId,
        pageSize: PAGE_SIZE,
        pageNo: 1,
        sortBy: sortFilter?.value || "desc",
      })
    );
  };

  const handleShipmentInfoDeliveryStatus = async (orderData) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    const updateData = {
      businessId: businessId,
      cartId: orderData?.cartId,
      data: {
        status: "OUTFORDELIVERY",
      },
    };
    const deliveryStatus = await deliveryStatusShippmentApi(updateData);
    if (deliveryStatus) {
      handleSucessIntransit();
    }
  };

  const handleShipmentInfoOrderDelivered = async (orderData) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    const updateData = {
      businessId: businessId,
      cartId: orderData?.cartId,
      data: {
        businessNotes: " Order Delivered to Customer",
      },
    };

    // setUnicomError("")

    // const catalogPartner =
    //   commerceInfo?.info?.catalogPartnerInfo?.[0]?.catalogPartner;

    // if (catalogPartner?.toLowerCase() == "unicommerce") {
    //   // Get Unicommerce Sale Order Info
    //   const unicommerceOrderInfo = await unicomGetSaleOrder({
    //     orderId: orderData?.orderId,
    //     businessId,
    //   });

    //   if (unicommerceOrderInfo?.saleOrderDTO) {
    //     const shippingPackageCode =
    //       unicommerceOrderInfo?.saleOrderDTO?.shippingPackages?.[0]?.code || "";

    //     if (!shippingPackageCode) {
    //       setUnicomError(
    //         "The shipping package for the Unicommerce order has not been generated yet. Please try again in a few minutes."
    //       );
    //       return
    //     }

    //     const dispatchPostData = {
    //       shippingPackageCode: shippingPackageCode,
    //       shippingProviderCode: "",
    //       trackingNumber: "",
    //       skipDetailing: true,
    //       skipChannelInvoicing: false,
    //       invoiceCode: "",
    //     };

    //     await unicommerceForceDispatch({
    //       facilityCode: "DemoStore1",
    //       businessId: businessId,
    //       data: dispatchPostData,
    //     });
    //   }
    // }

    const deliveryStatus = await orderDeliveredShippmentApi(updateData);

    if (deliveryStatus) {
      handleSucessIntransit();
    }
  };

  const handleSortByFilter = (data) => {
    const sortBy = data?.value || "desc";

    if (sortBy === sortBy?.value) return;

    setSortFilter(data);
    console.log("handleSortByFilter___", data);

    const businessId = sessionStorage.getItem("selectedBusinessId");
    dispatch(handleRefreshTabData());
    dispatch(
      refreshIntransitOrderData({
        businessId,
        pageSize: PAGE_SIZE,
        pageNo: 1,
        sortBy: data?.value || "desc",
      })
    );
  };

  const getPageCount = () => {
    return Math.ceil(totalOrders / PAGE_SIZE);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getOrdersData(value);
  };

  const getPaginationText = (pageNo, pageSize, totalOrders) => {
    const start = (pageNo - 1) * pageSize + 1;
    const end = Math.min(pageNo * pageSize, totalOrders);
    return `${start} to ${end} of ${totalOrders} orders`;
  };

  const onDownloadAll = () => {
    setBulkDownloadError("");
    const isValid = intransitOrders?.some((item) => item?.isSelected);
    if (!isValid) {
      setBulkDownloadError("Please select one or more orders");
      return;
    }

    const downloadList = intransitOrders?.filter((item) => item?.isSelected);

    if (downloadList?.length > 25) {
      setBulkDownloadError("Please select Max 25 orders in one set");
      return;
    }
    setBulkDownload({ show: true, data: downloadList });
  };

  useEffect(() => {
    getOrdersData(1);
    return () => {
      dispatch(clearIntransitOrderInfo());
    };
  }, []);

  // useEffect(() => {
  //   if ((intransitPageNo - 1) * PAGE_SIZE > intransitOrders?.length) {
  //     setHasMoreData(false);
  //   }

  //   return () => {};
  // }, [intransitPageNo]);

  return (
    <Box>
      <SearchOrdersById
        handleTrackOrder={handleTrackOrder}
        handleViewOrder={handleViewOrder}
        handleCancelOrder={handleCancelOrder}
        onSearchStart={onSearchStart}
        onSearchClear={onSearchClear}
        steps={steps}
        activeStep={tabValue}
        tabValue={tabValue}
        handleResendB2B={handleResendB2B}
        handleResend={handleResend}
        error={error}
        success={success}
        disableSearch={intransitOrders?.length == 0}
        getOndcBapNameBySubscriberId={getOndcBapNameBySubscriberId}
        downloadShipingLabel={downloadShipingLabel}
        downloadInvoiceAndShipingLabel={downloadInvoiceAndShipingLabel}
        invoiceDownloadLoader={invoiceDownloadLoader}
        downloadInvoice={downloadInvoice}
        sortFilter={sortFilter}
        setSortFilter={(value) => handleSortByFilter(value)}
      />
      {/* {tabValue >= 2 && tabValue <= 3 && (
        <Box display={{ xs: "block", md: "none" }} mb={3}>
          <HorizontalStepper steps={steps} activeStep={tabValue} />
        </Box>
      )} */}

      {intransitOrders?.length > 0 && (
        <Box
          sx={{
            ...stickyHeader,
            pb: { md: 0, xs: 0 },
            pt: 0,
            top: 275,
            display: { md: "block", xs: "none" },
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            mb={1.5}
          >
            <Typography
              color={blackShade19}
              fontSize={13}
              fontWeight={500}
              mt={0.5}
            >
              Download multiple invoices and shiping label with just{" "}
              <Typography
                component="span"
                color={orangeColor02}
                fontWeight={600}
              >
                ONE
              </Typography>{" "}
              click! Select your orders, click on{" "}
              <Typography
                component="span"
                color={orangeColor02}
                fontWeight={600}
              >
                'DOWNLOAD ALL'{" "}
              </Typography>
              .
            </Typography>

            <Stack alignItems="flex-end">
              <Button
                variant="contained"
                disableElevation
                sx={styles.approveBtn}
                startIcon={<DownloadIcon sx={{ fontSize: "16px!important" }} />}
                onClick={onDownloadAll}
              >
                Download All{" "}
                {selectedInTransitRowCount > 0 &&
                  `(${selectedInTransitRowCount})`}
              </Button>
              {bulkDownloadError ? (
                <Typography
                  variant="subtitle1"
                  component="p"
                  fontSize={12}
                  sx={{ mt: "4px !important", textAlign: "end", color: "red" }}
                >
                  {bulkDownloadError}
                </Typography>
              ) : null}
            </Stack>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={1}
          >
            <Typography color={blackShade19} fontWeight={500} fontSize={12}>
              {getPaginationText(page, PAGE_SIZE, totalOrders)}
            </Typography>
            <Pagination
              count={getPageCount()}
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
          <Box sx={styles.card}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={3}>
                <Box display="flex" alignItems="center" gap={2}>
                  <Box
                    sx={{
                      backgroundColor: whiteColor,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      // size=""
                      checked={intransitOrders?.every(
                        (item) => item.isSelected
                      )}
                      onChange={({ target }) => {
                        dispatch(
                          selectAllIntransitRows({
                            intransitOrders,
                            isSelected: target.checked,
                          })
                        );
                      }}
                      sx={styles.checkbox}
                    />
                  </Box>
                  <Typography
                    variant="h5"
                    fontSize={13}
                    fontWeight={500}
                    color={blackShade23}
                  >
                    ORDER DETAIL
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} md={2.4}>
                <Typography
                  variant="h5"
                  fontSize={13}
                  fontWeight={500}
                  color={blackShade23}
                >
                  CUSTOMER INFO & PRICE & QTY
                </Typography>
              </Grid>

              <Grid item xs={6} md={2.25}>
                <Typography
                  variant="h5"
                  fontSize={13}
                  fontWeight={500}
                  color={blackShade23}
                >
                  DELIVERY TYPE & STATUS
                </Typography>
              </Grid>

              <Grid item xs={6} md={2.2}>
                <Typography
                  variant="h5"
                  fontSize={13}
                  fontWeight={500}
                  color={blackShade23}
                >
                  PICKUP & DELIVERY DETAILS
                </Typography>
              </Grid>
              <Grid item xs={12} md={2.15}>
                <Stack flexDirection="row" alignItems="center" gap={0.5}>
                  <Typography
                    variant="h5"
                    fontSize={12.5}
                    fontWeight={500}
                    color={blackShade23}
                  >
                    ACTION
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}

      {!intransitOrdersLoader &&
      intransitOrders?.length === 0 &&
      !isSearchActive ? (
        <ListEmptyCard
          icon={
            <ProductionQuantityLimitsOutlinedIcon sx={{ fontSize: "24px" }} />
          }
          text="No In Transit Orders Found"
          hideBtn
        />
      ) : (
        intransitOrdersLoader && <ThreeDotLoader />
      )}

      {intransitOrders?.length > 0 && !intransitOrdersLoader && (
        <>
          {/* <InfiniteScroll
            dataLength={intransitOrders?.length || 0}
            next={fetchNextData}
            hasMore={hasMoreData}
            loader={
              <Box>
                <ThreeDotLoader />
              </Box>
            }
          > */}
          {intransitOrders?.map((item, index) => (
            <OrderIntransitCard
              index={index}
              key={`order_${item?.orderId}`}
              id={item?.orderId}
              ondcOrderId={item?.ondcOrderId || ""}
              date={moment(item?.orderCreatedOn)?.format(
                "Do MMM, YYYY hh:mm A"
              )}
              username={item?.customerAddressName}
              addressName={item?.customerAddressName || ""}
              city={item?.customerCity}
              addressCity={item?.customerAddressCity || ""}
              orderCost={item?.orderTotalCost}
              cartCount={item?.totalQuantity}
              orderType={getOrderType(item)}
              orderStatus="Shipped"
              deliveryType={getOrderDeliveryTypeText(
                item?.deliveryType?.type,
                item?.deliveryType?.shipType || ""
              )}
              carrierId={item?.shipmentInfo?.carrierTrackId || ""}
              // statusUpdatedDate={
              //   item?.orderShippedOn
              //     ? moment(item?.orderShippedOn).fromNow()
              //     : ""
              // }
              statusUpdatedDate={
                item?.orderShippedOn
                  ? formatMSToHoursAndMinutes(item?.orderShippedOn)
                  : ""
              }
              etaDeliveryDate={
                item?.shipmentInfo?.etaDeliveryDate
                  ? moment(item?.shipmentInfo?.etaDeliveryDate)?.format(
                      "Do MMM, YYYY"
                    )
                  : ""
              }
              etaDeliveryTime={
                item?.shipmentInfo?.etaDeliveryTime
                  ? moment(item?.shipmentInfo?.etaDeliveryTime)?.format(
                      "hh:mm A"
                    )
                  : ""
              }
              orderApprovedOn={
                item?.approvalTime ? formatStrTime(item?.approvalTime) : "N/A"
              }
              handleTrackOrder={() => {
                handleTrackOrder(item);
              }}
              handleViewOrder={() => handleViewOrder(item)}
              handleCancelOrder={() => handleCancelOrder(item)}
              handleResendB2B={handleResendB2B}
              handleResend={handleResend}
              error={error}
              success={success}
              orderData={item}
              handleShipmentInfoDeliveryStatus={
                handleShipmentInfoDeliveryStatus
              }
              handleShipmentInfoOrderDelivered={
                handleShipmentInfoOrderDelivered
              }
              getOndcBapNameBySubscriberId={() =>
                getOndcBapNameBySubscriberId(item?.ondcBapId)
              }
              downloadShipingLabel={downloadShipingLabel}
              downloadInvoiceAndShipingLabel={() => {
                downloadInvoiceAndShipingLabel(item);
              }}
              invoiceDownloadLoader={invoiceDownloadLoader}
              downloadInvoice={() => downloadInvoice(item)}
              unicomError={unicomError}
              isSelected={item?.isSelected}
              orders={intransitOrders}
            />
          ))}
          {/* </InfiniteScroll> */}
        </>
      )}

      {openCancelOrder?.show && (
        <OrderCancelPopup
          open={openCancelOrder?.show}
          handleClose={() => {
            setOpenCancelOrder({ show: false, data: null });
            handleApproveSuccess();
          }}
          handleCloseModal={() => {
            setOpenCancelOrder({ show: false, data: null });
          }}
          data={openCancelOrder?.data || null}
          commerceInfo={commerceInfo}
          orderShipStatus="transit"
          getOndcBapNameBySubscriberId={getOndcBapNameBySubscriberId}
        />
      )}

      {bulkDownload?.show && (
        <BulkDownloadContent
          modal={bulkDownload?.show}
          setModal={setBulkDownload}
          data={bulkDownload?.data}
        />
      )}
    </Box>
  );
}

export default IntransitOrdersContent;
const styles = {
  card: {
    display: { md: "flex", xs: "none" },
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "16px", md: "20px" },
    backgroundColor: greyColor42,
    borderTop: orderCardBorder,
    borderRadius: "7px 7px 0px 0px",
    boxShadow: "0 2px 4px rgb(179 188 198 / 5%)",
    // padding: "10px 10px 0px 10px",
    padding: "7px 15px",
    position: "sticky",
    top: 280,
    zIndex: 10000,
    // marginBottom: "15px",
  },
  approveBtn: {
    padding: "3px 13px",
    width: { md: "auto", xs: "auto" },
    fontSize: "12px",
    fontWeight: 600,
    maxWidth: "fit-content",
    color: { md: blueColor04, xs: mobilePrimary },
    backgroundColor: whiteColor,
    border: {
      md: "1px solid " + blueColor04,
      xs: "1px solid " + mobilePrimary,
    },
    "&:hover": {
      color: whiteColor,
      backgroundColor: { md: blueColor04, xs: mobilePrimary },
    },

    "&.Mui-disabled": {
      border: "none",
    },
  },

  checkbox: {
    color: greyColor21,
    p: 0,
    // backgroundColor: whiteColor,
    transform: "scale(1.3)",
    "&.Mui-checked": {
      color: blueColor04,
    },
  },
};
